













































































































































































































































import { Vue, Component, Prop } from "vue-property-decorator";
import { refResepStore } from "@/store/modules/ReferensiResep";
import ObatSearchBox from "@/components/resep/ObatSearchBox.vue";
import {
  RacikanTerstruktur,
  ReferensiBaris,
  SIGNA_LAIN,
  cocokAlergi,
  komponenBaru,
  labelSigna,
  masalahRacikan,
  namaEtiketRacikan,
  pratinjauAturanPakai,
  signaUntukSediaan
} from "@/utils/resepTerstruktur";

const URUTAN_FOKUS = [
  "nama",
  "sediaan",
  "qty",
  "signa",
  "signaBebas",
  "dosis",
  "satuan",
  "aturan",
  "rute",
  "bud"
];

const SATUAN_KOMPONEN_BAWAAN = "mg";

@Component({ components: { ObatSearchBox } })
export default class RacikanTerstrukturRow extends Vue {
  @Prop({ required: true }) racikan!: RacikanTerstruktur;
  @Prop({ required: true }) index!: number;
  @Prop({ default: "" }) depoId!: string;
  @Prop({ default: "" }) alergi!: string;
  @Prop({ type: Boolean, default: false }) tampilkanMasalah!: boolean;
  @Prop({ type: Boolean, default: false }) ringkas!: boolean;

  sediaanIdTerakhir: number | null = null;

  get kolom(): Record<string, number> {
    return this.ringkas
      ? {
          nama: 3,
          sediaan: 3,
          jumlah: 2,
          signa: 4,
          dosis: 2,
          satuan: 2,
          aturan: 3,
          rute: 3,
          bud: 2
        }
      : {
          nama: 2,
          sediaan: 2,
          jumlah: 1,
          signa: 2,
          dosis: 1,
          satuan: 1,
          aturan: 1,
          rute: 1,
          bud: 1
        };
  }

  get referensi(): ReferensiBaris {
    return {
      signa: (refResepStore.refFrekuensi || []) as any,
      rute: (refResepStore.refRute || []) as any,
      satuan: refResepStore.refSatuanDosis || [],
      aturan: refResepStore.refAturanTambahan || []
    };
  }

  get opsiSediaan() {
    return (refResepStore.refSediaan || []).filter(
      (s: any) =>
        !s.disabled || Number(s.id) === Number(this.racikan.sediaan_id)
    );
  }

  get sediaanTerpilih(): any {
    return (refResepStore.refSediaan || []).find(
      (s: any) => Number(s.id) === Number(this.racikan.sediaan_id)
    );
  }

  get budBawaan(): number | null {
    return this.budSediaan(this.sediaanTerpilih);
  }

  budSediaan(sediaan: any): number | null {
    const bud = sediaan ? Number(sediaan.bud_hari) : 0;
    return bud > 0 ? bud : null;
  }

  cariSediaan(id: number | null): any {
    return (refResepStore.refSediaan || []).find(
      (s: any) => id !== null && Number(s.id) === Number(id)
    );
  }

  get namaSediaan() {
    return this.sediaanTerpilih ? this.sediaanTerpilih.nama : "";
  }

  get opsiSigna() {
    const daftar = signaUntukSediaan(
      this.referensi,
      null,
      this.racikan.frekuensi_id
    ).map(signa => ({ value: signa.id, teks: labelSigna(signa) }));
    return [
      ...daftar,
      { value: SIGNA_LAIN, teks: "Lain-lain (tulis sendiri)" }
    ];
  }

  get opsiSatuan() {
    return this.referensi.satuan.filter(
      s =>
        s.tipe === "DOSIS" &&
        (!s.disabled || Number(s.id) === Number(this.racikan.satuan_dosis_id))
    );
  }

  get opsiSatuanKomponen() {
    return [...this.referensi.satuan]
      .filter(s => !s.disabled)
      .sort((a, b) => (a.tipe === b.tipe ? 0 : a.tipe === "KEKUATAN" ? -1 : 1));
  }

  get opsiAturan() {
    return this.referensi.aturan.filter(
      a =>
        !a.disabled || this.racikan.aturan_tambahan_ids.includes(Number(a.id))
    );
  }

  get opsiRute() {
    return this.referensi.rute.filter(
      r => !r.disabled || Number(r.id) === Number(this.racikan.rute_id)
    );
  }

  get pilihanSigna() {
    return this.racikan._signa_lain ? SIGNA_LAIN : this.racikan.frekuensi_id;
  }

  set pilihanSigna(nilai: any) {
    if (nilai === SIGNA_LAIN) {
      this.racikan._signa_lain = true;
      this.racikan.frekuensi_id = null;
      this.$nextTick(() => this.fokus("signaBebas"));
    } else {
      this.racikan._signa_lain = false;
      this.racikan.signa_bebas = null;
      this.racikan.frekuensi_id = nilai ?? null;
    }
  }

  get pratinjau() {
    return pratinjauAturanPakai(this.racikan, this.referensi);
  }

  get namaEtiket() {
    return namaEtiketRacikan(this.racikan, this.referensi);
  }

  get masalah() {
    return masalahRacikan(this.racikan);
  }

  get rowClass() {
    return this.masalah ? "row-invalid" : "row-ok";
  }

  created() {
    this.sediaanIdTerakhir = this.racikan.sediaan_id;
  }

  mounted() {
    if (this.racikan._fokus) {
      this.racikan._fokus = false;
      this.$nextTick(() => this.fokus("sediaan"));
    }
  }

  fokus(ref: string) {
    const target = this.$refs[ref] as any;
    const komponen = Array.isArray(target) ? target[0] : target;
    if (komponen && typeof komponen.focus === "function") {
      komponen.focus();
      return true;
    }
    return false;
  }

  fokusCariKomponen() {
    this.$nextTick(() => this.fokus("cariKomponen"));
  }

  pindahFokus(event: KeyboardEvent) {
    const sumber = event.target as Node;
    const urutan = URUTAN_FOKUS.filter(ref => !!this.$refs[ref]);
    const posisi = urutan.findIndex(ref => {
      const komponen = this.$refs[ref] as any;
      return komponen && komponen.$el && komponen.$el.contains(sumber);
    });

    if (posisi < 0) {
      return;
    }

    event.preventDefault();

    this.$nextTick(() => {
      const berikut = urutan[posisi + 1];
      if (!berikut || !this.fokus(berikut)) {
        this.fokus("cariKomponen");
      }
    });
  }

  pilihSediaan() {
    const budLama = this.budSediaan(this.cariSediaan(this.sediaanIdTerakhir));
    this.sediaanIdTerakhir = this.racikan.sediaan_id;
    const sediaan = this.sediaanTerpilih;
    if (!sediaan) return;
    if (sediaan.rute_default_id) {
      this.racikan.rute_id = Number(sediaan.rute_default_id);
    }
    if (sediaan.satuan_dosis_default_id) {
      this.racikan.satuan_dosis_id = Number(sediaan.satuan_dosis_default_id);
      if (!this.racikan.dosis_qty) {
        this.racikan.dosis_qty = 1;
      }
    }
    const budSekarang = Number(this.racikan.bud_hari) || null;
    if (budSekarang === null || budSekarang === budLama) {
      this.racikan.bud_hari = this.budSediaan(sediaan);
    }
  }

  tambahKomponen(obat: any) {
    if (cocokAlergi(this.alergi, obat.nama)) {
      const lanjut = confirm(
        `PERHATIAN — pasien memiliki alergi "${this.alergi}" dan komponen yang dipilih (${obat.nama}) mungkin terkait. Tetap tambahkan?`
      );
      if (!lanjut) return;
    }

    const mg = this.referensi.satuan.find(
      s => s.kode === SATUAN_KOMPONEN_BAWAAN
    );
    this.racikan.komponen.push(
      komponenBaru({
        obat_id: obat.id,
        obat_nama: obat.nama,
        gnr: obat.gnr || null,
        satuan_dosis_id: mg ? Number(mg.id) : null
      })
    );
    const posisi = this.racikan.komponen.length - 1;
    this.$nextTick(() => this.fokus(`dosisKomponen${posisi}`));
  }

  hapusKomponen(i: number) {
    this.racikan.komponen.splice(i, 1);
  }
}
